var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "complaint-container clearfix swb-back-row" }, [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("查看详情")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "right",
              on: {
                click: function($event) {
                  _vm.$router.back(-1)
                }
              }
            },
            [_vm._m(0)]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "complaint-content mr15",
          staticStyle: { "margin-left": "0" }
        },
        [
          _c("h4", { staticClass: "title" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.complaintInfo.srcMerchantName) +
                  " 投诉 " +
                  _vm._s(_vm.complaintInfo.dstMerchantName)
              )
            ]),
            _vm._v(" "),
            !_vm.complaintInfo.closed
              ? _c("div", { staticClass: "fr" }, [
                  _vm.complaintInfo.acceptState != 0
                    ? _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "swb-btn swb-btn-mini",
                            on: {
                              click: function($event) {
                                _vm.complaintSend(_vm.complaintInfo.id)
                              }
                            }
                          },
                          [_vm._v("重新申诉")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "swb-btn swb-btn-mini",
                            on: {
                              click: function($event) {
                                _vm.arbitration(_vm.complaintInfo.id)
                              }
                            }
                          },
                          [_vm._v("平台介入")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "swb-btn swb-btn-mini",
                            on: {
                              click: function($event) {
                                _vm.complaintEnd(_vm.complaintInfo.id)
                              }
                            }
                          },
                          [_vm._v("结束申诉")]
                        )
                      ])
                    : _vm._e()
                ])
              : _c("div", { staticClass: "fr" }, [
                  _c("a", { staticClass: "swb-btn-link" }, [
                    _vm._v("投诉已关闭")
                  ])
                ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pl10 pr10 pb10" },
            _vm._l(_vm.complaintRecList, function(complaintRec) {
              return _c("div", { staticClass: "complaint-panel" }, [
                _c("div", { staticClass: "complaint-panel-item" }, [
                  _c("h4", [
                    _c("span", {}, [
                      _vm._v(
                        _vm._s(_vm.complaintInfo.srcMerchantName) +
                          _vm._s(_vm.complaintInfo.acceptState)
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.complaintInfo.submitTime))])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ml5" }, [
                    _c("span", { staticClass: "font16 font-bold" }, [
                      _vm._v("投诉内容：")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(complaintRec.srcContent))])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "ml5 mt10" }, [
                    _c("span", { staticClass: "font16 font-bold" }, [
                      _vm._v("处理要求：")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(complaintRec.srcDemand))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "img111" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "complaint-panel-item" }, [
                  _c("h4", { staticClass: "align-right" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.complaintInfo.dstMerchantName))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.complaintInfo.submitTime))])
                  ]),
                  _vm._v(" "),
                  complaintRec.dstAcceptState == 1
                    ? _c("p", { staticClass: "align-right" }, [
                        _c("a", { staticClass: "swb-btn-link" }, [
                          _vm._v("已接收")
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  complaintRec.dstAcceptState == -1
                    ? _c("p", { staticClass: "align-right" }, [
                        _c("a", { staticClass: "swb-btn-link" }),
                        _vm._v("已拒绝")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "ml5" }, [
                    _c("span", { staticClass: "font14 font-bold" }, [
                      _vm._v("留言说明：")
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(complaintRec.dstContent))])
                  ])
                ])
              ])
            })
          )
        ]
      ),
      _vm._v(" "),
      _vm.complaintorderOrderInfo != null
        ? _c("div", { staticClass: "order-info" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("订单信息")]),
            _vm._v(" "),
            _c("div", { staticClass: "order-content" }, [
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("订单编号：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.no))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("总计：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-red" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.amount) + "元")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("提交时间：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.submitTime))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "order-content-row" }, [
                _c("div", { staticClass: "left" }, [_vm._v("商家：")]),
                _vm._v(" "),
                _c("div", { staticClass: "right font-blue" }, [
                  _vm._v(_vm._s(_vm.complaintorderOrderInfo.sellerName))
                ])
              ])
            ])
          ])
        : _c("div", { staticClass: "order-info" }, [
            _c("h4", { staticClass: "title" }, [_vm._v("订单信息")]),
            _vm._v(" "),
            _vm._m(1)
          ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "swb-btn swb-btn-link" }, [
      _c("i", { staticClass: "icon iconfont icon-fanhui2 mr5" }),
      _vm._v("返回")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "order-content align-center",
        staticStyle: { "min-height": "170px", "line-height": "170px" }
      },
      [_c("span", { staticClass: "font16" }, [_vm._v("暂无数据。。。")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51804090", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51804090","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/custsvc/ComplaintInfo.vue
// module id = 2709
// module chunks = 0